// @flow
import React, { Component } from 'react'
import { Link } from 'react-router'
import format from 'date-fns/format'
import colors from '../../../../styles/colors'
import Table from '../../../../components/Table'
import Tr from '../../../../components/Tr'
import Th from '../../../../components/Th'
import AdminOfferFormRow from '../AdminOfferFormRow'

type Props = {
  offer: Object,
  onUpdate: Function
}

class AdminOfferForm extends Component {
  props: Props

  handleRowUpdate = (data: Object) => {
    const { offer } = this.props
    this.props.onUpdate(offer.user_id, offer.id, data)
  }

  render() {
    const { offer } = this.props

    return (
      <div style={{ marginBottom: '2rem' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            marginBottom: '1rem'
          }}
        >
          <div>
            <h5>
              MLS#{' '}
              <Link to={`/properties/${offer.mls_id}`}>{offer.listing_id}</Link>
            </h5>
            <small style={{ color: 'rgb(120,130,140)' }}>
              Submitted {format(offer.inserted_at, 'MM/DD/YYYY')}
            </small>
          </div>
          <div>
            <h5>
              Offer amount&nbsp;
              <span style={{ color: colors.success }}>
                ${Number(offer.amount).toLocaleString()}
              </span>
            </h5>
          </div>
        </div>
        <Table>
          <thead>
            <Tr>
              <Th>Step</Th>
              <Th style={{ textAlign: 'right' }}>Status</Th>
            </Tr>
          </thead>
          <tbody>
            <AdminOfferFormRow
              label="Pre-approval"
              name="pre_approval"
              value={offer.pre_approval}
              onUpdate={this.handleRowUpdate}
            />
            <AdminOfferFormRow
              label="Agency agreement"
              name="agency_agreement"
              value={offer.agency_agreement}
              onUpdate={this.handleRowUpdate}
            />
            <AdminOfferFormRow
              label="Offer / Negotiation"
              name="negotiation"
              value={offer.negotiation}
              onUpdate={this.handleRowUpdate}
            />
            <AdminOfferFormRow
              label="Executed contract"
              name="executed_contract"
              value={offer.executed_contract}
              onUpdate={this.handleRowUpdate}
            />
            <AdminOfferFormRow
              label="Home inspection"
              name="home_inspection"
              value={offer.home_inspection}
              onUpdate={this.handleRowUpdate}
            />
            <AdminOfferFormRow
              label="Lender work / Appraisal"
              name="appraisal"
              value={offer.appraisal}
              onUpdate={this.handleRowUpdate}
            />
            <AdminOfferFormRow
              label="Title work"
              name="title"
              value={offer.title}
              onUpdate={this.handleRowUpdate}
            />
            <AdminOfferFormRow
              label="Close"
              name="close"
              value={offer.close}
              onUpdate={this.handleRowUpdate}
            />
          </tbody>
        </Table>
      </div>
    )
  }
}

export default AdminOfferForm



// WEBPACK FOOTER //
// ./src/views/AdminUserOffers/components/AdminOfferForm/index.js